import { CLEAR_STATE, DELETE_CARD, SAVE_CARD_DATA } from '../actions/ComponentCallsActions'

const initialState = {}

const CardStateReduer = function (state = initialState, action) {
    switch (action.type) {
        case SAVE_CARD_DATA: {
            return {
                ...state,
                cardData: { ...action.payload },
            }
        }
        case CLEAR_STATE: {
            return {
                ...initialState,
            }
        }
        default: {
            return {
                ...state,
            }
        }
    }
}

export default CardStateReduer
